import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import React, { Component } from 'react';

class App extends Component {
    editor = null;

    render() {
        return (
            <div className="ck_editor_new">
                <CKEditor
                    editor={DecoupledEditor}
                    data={this.props.data}
                    onReady={(editor) => {
                        // ✅ Correct way to insert toolbar
                        const editableElement = editor.ui.view.editable.element;
                        const toolbarElement = editor.ui.view.toolbar.element;

                        editableElement.parentElement.insertBefore(toolbarElement, editableElement);

                        this.editor = editor;
                    }}
                    onError={(error, { willEditorRestart }) => {
                        if (willEditorRestart && this.editor) {
                            this.editor.ui.view.toolbar.element.remove();
                        }
                    }}
                    onChange={(event, editor) => this.props.handleChange(editor.getData())}
                />
            </div>
        );
    }
}

export default App;
